import { render, staticRenderFns } from "./StudentSubjectStatusSummary.vue?vue&type=template&id=5633f0da&"
import script from "./StudentSubjectStatusSummary.ts?vue&type=script&lang=ts&"
export * from "./StudentSubjectStatusSummary.ts?vue&type=script&lang=ts&"
import style0 from "./StudentSubjectStatusSummary.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports